import React from "react";

import Routes from "./routes";
import "./styles/global.css";
import "leaflet/dist/leaflet.css"; //style necessario para nao baguncar o map

function App() {
  return <Routes />;
}

export default App;
